import Wrapper from 'pages/login/components/Wrapper';

const LoadingLogin = () => <Wrapper isLoading />;

export default LoadingLogin;
